module.exports = __webpack_public_path__ + "static/media/Mediation picture (1).3305393a.jpg";